var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { enterMail, validMail } from "@domains/utils/commonText";
import React, { useEffect, useRef, useState } from "react";
import { emailRegex } from "@frameworks/web/utils/regex";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import TeaxtAreaField from "../../../../shared-library/components/TextAreaField";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import di from "@frameworks/salesjourney/components/Features/LeadDashboard/di/serviceLocator";
import { v4 as uuidv4 } from "uuid";
import { Link } from "react-router-dom";
var SendEmail = function (props) {
    var _a = __read(useState([]), 2), emailList = _a[0], setEmailList = _a[1];
    var _b = __read(useState([]), 2), ccList = _b[0], setCCList = _b[1];
    var emailRef = useRef(null);
    var ccRef = useRef(null);
    var _c = __read(useState(), 2), currEmailvalue = _c[0], setCurrEmailValue = _c[1];
    var _d = __read(useState(), 2), currCCvalue = _d[0], setCurrCCValue = _d[1];
    var _e = __read(useState(""), 2), subject = _e[0], setSubject = _e[1];
    var _f = __read(useState(null), 2), message = _f[0], setMessage = _f[1];
    var _g = __read(useState(), 2), productRowSelection = _g[0], setProductRowSelection = _g[1];
    var _h = __read(useState(null), 2), emailFail = _h[0], setEmailFail = _h[1];
    var _j = __read(useState([]), 2), showClick = _j[0], setShowClick = _j[1];
    var EmailListUpdate = function (currentValue, setCurrentValue, list, setList) {
        if (emailRegex.test(currentValue) && !list.includes(currentValue)) {
            setList(__spreadArray(__spreadArray([], __read(list), false), [currentValue], false));
            setCurrentValue("");
            return __spreadArray(__spreadArray([], __read(list), false), [currentValue], false);
        }
    };
    var AddEmail = function (ref, list, setList, currentValue, setCurrentValue, name) {
        return (React.createElement(React.Fragment, null,
            list.length > 0 && (React.createElement("ul", { className: "mail_label_body" }, list &&
                list.map(function (el, idx) {
                    return (React.createElement("li", { key: idx, className: "d-flex align-items-center DMSan_14_500 txt_blackOne1" },
                        el,
                        React.createElement("i", { className: "edel-icon-rounded-close txt_redBorder", onClick: function () {
                                return setList(function (list) {
                                    return list.filter(function (_, i) { return list[i] !== el; });
                                });
                            } })));
                }))),
            React.createElement("div", { className: "mail-input d-flex align-items-center" },
                React.createElement("input", { ref: ref, type: "email", className: "form-control", placeholder: "Enter email address", name: name, pattern: emailRegex.source, value: currentValue, onChange: function (e) {
                        setCurrentValue(e.target.value);
                        e.target.setCustomValidity("");
                        ref.current.checkValidity();
                    }, required: list.length === 0, onInvalid: function (e) {
                        if (e.currentTarget.validity.valueMissing) {
                            return e.currentTarget.setCustomValidity(enterMail);
                        }
                        if (e.currentTarget.validity.patternMismatch) {
                            return e.currentTarget.setCustomValidity(validMail);
                        }
                    }, onKeyDown: function (e) {
                        if (e.key === "Enter") {
                            e.preventDefault();
                            EmailListUpdate(currentValue, setCurrentValue, list, setList);
                            if (ref && ref.current) {
                                ref.current.checkValidity();
                                ref.current.reportValidity();
                            }
                        }
                    } }),
                React.createElement("div", { className: "add-icon", onClick: function () {
                        EmailListUpdate(currentValue, setCurrentValue, list, setList);
                        if (ref && ref.current) {
                            ref.current.checkValidity();
                            ref.current.reportValidity();
                        }
                    } },
                    React.createElement("i", { className: "edel-icon-add txt-midnight-blue" })))));
    };
    var ProductTableColumn = [
        {
            columnName: "Product",
            key: "product",
        },
        {
            columnName: "Category",
            key: "category",
        },
        {
            columnName: "SubCategory",
            key: "subCategory",
        },
        {
            columnName: "Document Name",
            key: "documentName",
        },
        {
            columnName: "Show",
            key: "documentDownload",
            tdCustomFunction: function (key) {
                return (React.createElement(Link, { to: {}, target: "_self", rel: "noopener noreferrer", onClick: function () {
                        if (key)
                            setShowClick(function (prevState) {
                                if (!!prevState)
                                    return [key];
                                else
                                    prevState.map(function (m) {
                                        if (m != key)
                                            return __spreadArray(__spreadArray([], __read(prevState), false), [key], false);
                                    });
                                return prevState;
                            });
                    } }, "Show"));
            },
        },
        {
            columnName: "Select",
            key: "_Id",
            tdCustomFunction: function (key) {
                if (productRowSelection && productRowSelection.length > 0) {
                    var id = productRowSelection.find(function (x) { return x.id == key; });
                    return (React.createElement("input", { type: "checkbox", className: "form-check-input common-checkbox", checked: id.value, onClick: function (e) {
                            setProductRowSelection(productRowSelection.map(function (ele) {
                                if (ele.id === key) {
                                    return __assign(__assign({}, ele), { value: e.currentTarget.checked });
                                }
                                return ele;
                            }));
                        } }));
                }
            },
        },
    ];
    useEffect(function () {
        setProductRowSelection(props.leadPitchProducts.map(function (x) {
            return { id: x._Id, value: false };
        }));
    }, [props.leadPitchProducts]);
    useEffect(function () {
        if (showClick && showClick.length > 0) {
            showClick.map(function (v) {
                window.open(v);
                setShowClick(function (prevState) { return prevState.filter(function (y) { return y !== v; }); });
            });
        }
    }, [showClick]);
    var sendEmail = function () { return __awaiter(void 0, void 0, void 0, function () {
        var emails, zipFiles, i, j, payload, resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    emails = emailList.join(";");
                    zipFiles = [];
                    for (i = 0; i < props.leadPitchProducts.length; i++)
                        for (j = 0; j < productRowSelection.length; j++)
                            if (props.leadPitchProducts[i]._Id === productRowSelection[j].id)
                                zipFiles.push(props.leadPitchProducts[i].documentPath);
                    payload = {
                        pitchEmailId: emails,
                        pitchEmailBody: message,
                        zipFile: zipFiles.map(function (x) { return x; }).join(","),
                        leadId: uuidv4(),
                    };
                    return [4 /*yield*/, di.leads.sendProductPitchEmail(payload)];
                case 1:
                    resp = _a.sent();
                    if (resp) {
                        setEmailList([]);
                        setMessage("");
                        setProductRowSelection([]);
                        if (resp.response !== "Success")
                            setEmailFail(resp.responseDescription);
                        else
                            props.setToastEmailSuccess(resp.responseDescription);
                        props.setEmailPopup(false);
                    }
                    else
                        setEmailFail("Request Failed. Please try after sometime.");
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var timeId = setTimeout(function () {
            setEmailFail(null);
        }, 3000);
        return function () {
            clearTimeout(timeId);
        };
    }, [setEmailFail]);
    useEffect(function () {
        if (props === null || props === void 0 ? void 0 : props.email) {
            setEmailList([props === null || props === void 0 ? void 0 : props.email]);
        }
    }, [props === null || props === void 0 ? void 0 : props.email]);
    return (React.createElement(React.Fragment, null,
        React.createElement(GenericTable, { columns: ProductTableColumn, data: props.leadPitchProducts, parentClassName: "salestableParentClass my-3", tableClassName: "salestableclass" }),
        React.createElement("form", { onSubmit: function (e) {
                e.preventDefault();
            } },
            React.createElement("div", { className: "bg_aqua_white mail" },
                React.createElement("label", { className: "DMSanM_14_500 txt_blackOne1" },
                    "To",
                    React.createElement("span", { className: "redstar" }, "*")),
                (props === null || props === void 0 ? void 0 : props.email) ? (React.createElement("h3", null,
                    " ",
                    props.email)) : (AddEmail(emailRef, emailList, setEmailList, currEmailvalue, setCurrEmailValue, "to")),
                React.createElement("label", { className: "DMSanM_14_500 txt_blackOne1" },
                    "Message",
                    React.createElement("span", { className: "redstar" }, "*")),
                React.createElement(TeaxtAreaField, { id: "message", name: "message", required: true, placeholderClassName: "DMSanM_14_500 txt_blackOne1", defaultValue: message ? message : "", value: message ? message : "", onChangeEvent: function (e) { return setMessage(e.target.value); } })),
            emailFail && (React.createElement("div", { className: "DMSanM_14_500 txt_blackOne1 d-flex justify-content-center my-2" }, emailFail)),
            React.createElement("div", { className: "taCenter" },
                React.createElement(EdButton
                // type="submit"
                , { 
                    // type="submit"
                    onClick: function () {
                        sendEmail();
                    }, type: "button", btnTyp: "midnight-blue", value: "Send Email", className: "mt-4", disabled: (emailList === null || emailList === void 0 ? void 0 : emailList.length) > 0 &&
                        !!message &&
                        productRowSelection.some(function (x) { return x.value === true; })
                        ? false
                        : true })))));
};
export default SendEmail;
